module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av225-2f6b670d6be79968f0070eabe00d3c97.jpg";